const ACTIVE_META_TAGS = ['description', 'canonical', 'og:title', 'og:description', 'og:image', 'og:url', 'twitter:title', 'twitter:description', 'twitter:image', 'twitter:card'];
const META_TAGS_LOOKUP = {
  description: {
    apiKey: 'formattedMetaDescription',
    htmlTagName: 'meta',
    tagKeyName: 'name',
    contentDataKeyName: 'content'
  },
  canonical: {
    apiKey: 'canonicalUrl',
    htmlTagName: 'link',
    tagKeyName: 'rel',
    contentDataKeyName: 'href'
  },
  [ACTIVE_META_TAGS[2]]: {
    apiKey: 'titleToUse',
    htmlTagName: 'meta',
    tagKeyName: 'property',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[3]]: {
    apiKey: 'formattedMetaDescription',
    htmlTagName: 'meta',
    tagKeyName: 'property',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[4]]: {
    apiKey: 'imageUrl',
    htmlTagName: 'meta',
    tagKeyName: 'property',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[5]]: {
    apiKey: 'fullUrl',
    htmlTagName: 'meta',
    tagKeyName: 'property',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[6]]: {
    apiKey: 'titleToUse',
    htmlTagName: 'meta',
    tagKeyName: 'name',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[7]]: {
    apiKey: 'formattedMetaDescription',
    htmlTagName: 'meta',
    tagKeyName: 'name',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[8]]: {
    apiKey: 'imageUrl',
    htmlTagName: 'meta',
    tagKeyName: 'name',
    contentDataKeyName: 'content'
  },
  [ACTIVE_META_TAGS[9]]: {
    apiKey: 'twitterCard',
    htmlTagName: 'meta',
    tagKeyName: 'name',
    contentDataKeyName: 'content'
  }
};
const TWITTER_CARD = 'summary_large_image';
const SOCIAL_META = 'socialMeta';
export { ACTIVE_META_TAGS, META_TAGS_LOOKUP, TWITTER_CARD, SOCIAL_META };
//# sourceMappingURL=constants.js.map